import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'antd';

import { pageChanged } from '../../../data/redux/page_details/actions';
import { loginUser } from '../../../data/redux/admin_details/actions';
import { APP_PAGES, ROUTE_PATH } from '../../../data/config/constants';
import { showMessage, encrypt } from '../../../data/config/utils';
import { MODULE_MESSAGE, BRAND_INFO } from '../../../data/config/urls';

import LogoCard from '../../../components/logocard';
import InputFormItem from '../../../components/form/formitem/inputformitem';
import ModalFooter from '../../../components/modalfooter';

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class LoginForm extends Component {
  componentDidMount() {
    let { actions } = this.props;
    actions.pageChanged(APP_PAGES.LOGIN, 'ORI Dashboard');
  }

  handleInputChange = event => {
    this.props.form.setFieldsValue({
      [event.target.name]: event.target.value
    });
    this.props.form.validateFields();
  };

  handleSubmit = e => {
    e.preventDefault();
    const { form, actions, history } = this.props;
    form.validateFields(err => {
      if (!err) {
        const email = form.getFieldValue('email')
        const pwd = form.getFieldValue('password')
        const password = process.env.REACT_APP_CIPHER_SECRET_KEY ? encrypt(pwd) : pwd
        const payload = {
          email,
          password,
          isEncrypted: password !== pwd
        }
        actions.loginUser(payload, (error, response) => {
          if (error) {
            if (response && response.status === 'failed' && response.data && response.data.pathname)
              history.push(response.data.pathname);
          } else {
            if (history.location.state && history.location.state.from && history.location.state.from.pathname && history.location.state.from.pathname !== null && history.location.state.from.pathname.trim().length > 0)
              history.push(history.location.state.from.pathname);
            else
              history.push(ROUTE_PATH.DASHBOARD);
          }
        });
      } else {
        showMessage('error', 'Please enter/validate username and password!');
      }
    });
  };

  goToForgotPassword = () => {
    const { history } = this.props;
    history.push(ROUTE_PATH.FORGOT_PASSWORD);
  };

  render() {
    const { form, auth_loading } = this.props;
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = form;
    const emailError = isFieldTouched('email') && getFieldError('email');
    const passwordError = isFieldTouched('password') && getFieldError('password');

    return (
      <div className="ori-animated ori-fade-in-left ori-pad-10">
        <LogoCard
          container_class="ori-b-mrgn-20 ori-pad-15 ori-text-center"
          image_src={BRAND_INFO.logo_url}
          title={MODULE_MESSAGE.AUTH.LOGIN.title}
          title_class="ori-font-md"
          description={MODULE_MESSAGE.AUTH.LOGIN.description}
        />
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <InputFormItem
            getFieldDecorator={getFieldDecorator}
            validate_status={emailError ? "warning" : ""}
            help={emailError || ''}
            error_key="email"
            rules={
              [
                { required: true, message: 'Please input your emailid/username' }
              ]
            }
            placeholder="Email / username"
            input_name="email"
            disabled={auth_loading}
            onChange={this.handleInputChange}
          />
          <InputFormItem
            getFieldDecorator={getFieldDecorator}
            validate_status={passwordError ? "warning" : ""}
            help={passwordError || ''}
            error_key="password"
            rules={[{ required: true, message: 'Please enter your password!' }]}
            type="password"
            placeholder="Password"
            input_name="password"
            disabled={auth_loading}
            onChange={this.handleInputChange}
          />
          {/* <div className="ori-full-width ori-text-center ori-b-pad-10">
            <p className="ori-font-xs">{`By continuing on ${BRAND_INFO.shortend_name} chatbot, you agree to our`} <span className="ori-font-primary ori-link-primary">Terms & Conditions</span>  and <span className="ori-font-primary ori-link-primary">Privacy Policy</span>.</p>
          </div> */}
          <ModalFooter
            capsule_button
            hide_cancel_button
            container_class="ori-flex ori-tb-mrgn-10"
            ok_btn_class="ori-height-40 ori-full-width"
            button_ok_text={auth_loading ? "LOGGING" : "LOGIN"}
            button_ok_type="submit"
            loading={auth_loading}
            button_ok_disabled={hasErrors(getFieldsError()) || auth_loading}
          />
          <div className="ori-full-width ori-text-center">
            <p className="ori-font-xs ori-link-primary ori-font-primary" onClick={this.goToForgotPassword}>Forgot password?</p>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth_loading: state.admin_details.loaders.auth_loading,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        pageChanged,
        loginUser
      },
      dispatch
    ),
  };
}

LoginForm.propTypes = {
  form: PropTypes.object,
  actions: PropTypes.object,
  auth_loading: PropTypes.bool,
  history: PropTypes.object,
};

const Login = Form.create()(LoginForm);

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Login);


// WEBPACK FOOTER //
// ./src/app/authcontainer/login/index.js